/**
 * DEPLETIONS-INVENTORY MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

import { useNavigate } from "react-router-dom";
import InventoryPage from "../components/InventoryPage.jsx";

// Inventory screen — current on-hand stock with months/days-on-hand.
export default function Inventory() {
  const navigate = useNavigate();
  return <InventoryPage onHome={() => navigate("/")} />;
}
